/**
 * Labstep
 *
 * @module core/DataGrid/CellEditor/Date
 * @desc CellEditor Date
 */

import { FormShowEditDateContainer as FormShowEditDate } from 'labstep-web/core/Form/ShowEdit/Date';
import type { Entity } from 'labstep-web/models/entity.model';
import React from 'react';
import type { ICellEditorDateProps } from './types';

export const DataGridCellEditorDate: React.FC<
  ICellEditorDateProps<Entity>
> = React.memo((params) => (
  <FormShowEditDate
    dateTimePickerOnly
    onClose={(): void => params.api.stopEditing()}
    {...params.props}
  />
));
